import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearDifferencialProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearDifferencial(props: RearDifferencialProps) {
  return (
    <svg
      width="54"
      height="62"
      viewBox="0 0 54 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 220, right: 275}}
      onClick={props.onClick}
    >
      <path
        d="M53 11.7143L47 57.7857C46.5 61 46 61 43 61H27H11C8 61 7.5 61 7 57.7857L1 11.7143V4.21429C1 4.21429 1 1 4 1H27H50C53 1 53 4.21429 53 4.21429V11.7143Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M53 11.7143L47 57.7857C46.5 61 46 61 43 61H27H11C8 61 7.5 61 7 57.7857L1 11.7143V4.21429C1 4.21429 1 1 4 1H27H50C53 1 53 4.21429 53 4.21429V11.7143Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1.00012 11H53.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M6 53L48 53"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M15.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M19.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M5.00012 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M25.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M35.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M9.00012 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M45.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M49.0001 1V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path d="M35 53V61" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M39 53V61" stroke="currentColor" className={partStroke({variant: props.variant})} />
    </svg>
  );
}
